import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "contact",
  class: "bg-primary py-5"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "display-4 fw-bold text-light pt-5 pb-3" }, " We'll have you at hello. ", -1)
const _hoisted_3 = { class: "row d-flex justify-content-center mx-5" }
const _hoisted_4 = { class: "col-lg-3 p-2" }
const _hoisted_5 = { class: "col-lg-3 p-2" }
const _hoisted_6 = { class: "col-lg-3 p-2" }
const _hoisted_7 = { class: "row d-flex justify-content-center mx-5" }
const _hoisted_8 = { class: "col-lg-9 p-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light text-primary fw-bold fs-5 mt-3 btn-lg shadow-0"
}, "Talk with an Ambassador!", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MDBInput = _resolveComponent("MDBInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_MDBInput, {
          label: "First Name",
          type: "text",
          size: "lg",
          white: ""
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_MDBInput, {
          label: "Last Name",
          type: "text",
          size: "lg",
          white: ""
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_MDBInput, {
          label: "Email",
          type: "email",
          size: "lg",
          white: ""
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_MDBInput, {
          label: "Comments",
          type: "text",
          size: "lg",
          white: ""
        })
      ])
    ]),
    _hoisted_9
  ]))
}